import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { GetMyProfileResponse, UpdateMyEmailsRequest } from '../../types/auth.js'

import { apiClient } from '../../lib/client.js'
import { meKeys } from './keys.js'

export const useUpdateMyEmailsMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: UpdateMyEmailsRequest) => {
      const response = await apiClient.client.put<GetMyProfileResponse>('/me/emails', data)
      return response.data
    },
    onError: () => {
      void queryClient.invalidateQueries({ queryKey: meKeys.profile })
      void queryClient.invalidateQueries({ queryKey: meKeys.me })
    },
    onMutate: async (data) => {
      await queryClient.cancelQueries({ queryKey: meKeys.profile })

      const previousProfile = queryClient.getQueryData<GetMyProfileResponse>(meKeys.profile)

      if (previousProfile) {
        queryClient.setQueryData<GetMyProfileResponse>(meKeys.profile, {
          ...previousProfile,
          client: previousProfile.client
            ? {
                ...previousProfile.client,
                secondaryEmail: data.secondaryEmail ?? previousProfile.client.secondaryEmail,
              }
            : null,
          user: {
            ...previousProfile.user,
            email: data.email,
          },
        })
      }

      return { previousProfile }
    },
  })
}
